import type { IOrgProjectLocationRepository } from '../repositories/IOrgProjectLocationRepository.js';

interface Deps { orgProjectLocationRepository: IOrgProjectLocationRepository; }

export function createUnsubscribeOrgLocationUseCase({ orgProjectLocationRepository }: Deps) {
  return async function unsubscribeOrgLocation(orgId: string, locationId: string): Promise<void> {
    const stillInProjects = await orgProjectLocationRepository.hasProjectSubscriptions(orgId, locationId);
    if (stillInProjects) {
      throw new Error('Địa điểm này vẫn đang được đăng ký cho một hoặc nhiều dự án trong org. Hãy huỷ đăng ký khỏi tất cả dự án trước.');
    }
    return orgProjectLocationRepository.unsubscribeOrg(orgId, locationId);
  };
}
